(function() {
  'use strict';

  // Check if we're on mobile
  function isMobile() {
    return window.matchMedia('(max-width: 1007px)').matches;
  }

  // Preload images function
  function preloadImage(url) {
    if (!url || url === '') return null;
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  }

  // Preload all content images
  function preloadAllContentImages() {
    const containers = document.querySelectorAll('.GangMembers__Container');
    const mobile = isMobile();
    
    containers.forEach(container => {
      const columns = Array.from(container.querySelectorAll('.GangMembers__Column'));
      const imagesToPreload = [];
      
      columns.forEach(column => {
        let desktopUrl = column.getAttribute('data-content-image-desktop');
        let mobileUrl = column.getAttribute('data-content-image-mobile');
        
        // Preload desktop image
        if (desktopUrl && desktopUrl !== '') {
          imagesToPreload.push(preloadImage(desktopUrl));
        }
        
        // Preload mobile image (if different from desktop)
        if (mobileUrl && mobileUrl !== '' && mobileUrl !== desktopUrl) {
          imagesToPreload.push(preloadImage(mobileUrl));
        }
      });
      
      // Preload all images in parallel
      Promise.all(imagesToPreload).catch(() => {
        // Silently fail if some images don't load
      });
    });
  }

  function initGangMembers() {
    const containers = document.querySelectorAll('.GangMembers__Container');
    const mobile = isMobile();
    
    containers.forEach(container => {
      const columns = Array.from(container.querySelectorAll('.GangMembers__Column'));
      
      columns.forEach((column, index) => {
        // Remove existing event listener if any (by cloning without event listeners)
        const hasListener = column.hasAttribute('data-listener-attached');
        if (hasListener) {
          return; // Already has listener, skip
        }
        
        column.setAttribute('data-listener-attached', 'true');
        
        // Preload content image on hover (desktop only)
        if (!mobile) {
          let hoverTimeout;
          column.addEventListener('mouseenter', function() {
            clearTimeout(hoverTimeout);
            hoverTimeout = setTimeout(function() {
              const desktopUrl = column.getAttribute('data-content-image-desktop');
              if (desktopUrl && desktopUrl !== '') {
                preloadImage(desktopUrl).catch(() => {});
              }
            }, 100); // Small delay to avoid preloading on accidental hovers
          });
          
          column.addEventListener('mouseleave', function() {
            clearTimeout(hoverTimeout);
          });
        }
        
        column.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const isActive = column.classList.contains('GangMembers__Column--active');
          const isMobileNow = isMobile();
          
          // Get fresh columns array
          const currentColumns = Array.from(container.querySelectorAll('.GangMembers__Column'));
          
          // Remove active class from all columns and reset transforms
          currentColumns.forEach((col, colIndex) => {
            col.classList.remove('GangMembers__Column--active');
            col.style.transform = '';
            col.style.left = '';
            col.style.right = '';
            col.style.top = '';
            col.style.bottom = '';
            col.style.zIndex = '6'; // Always higher than content area (5)
            col.style.opacity = '1'; // Ensure full opacity
            col.dataset.columnState = 'normal';
          });
          
          // Remove spacer if exists
          const existingSpacer = container.querySelector('.GangMembers__Spacer');
          if (existingSpacer) {
            existingSpacer.remove();
          }
          
          // Remove container active state immediately (needed for proper column positioning)
          container.classList.remove('GangMembers__Container--has-active');
          
          // When closing, keep content area visible - columns will cover it during animation
          const contentArea = container.querySelector('.GangMembers__ContentArea');
          if (contentArea) {
            // Keep content area visible with full opacity during closing animation
            // Don't clear content - it will be covered by columns as they move back
            contentArea.style.opacity = '1';
            contentArea.style.visibility = 'visible';
            contentArea.style.zIndex = '5';
            // Note: Content stays visible and gets covered by columns (z-index 6)
          }
          
          // When closing, ensure all columns have higher z-index than content area
          currentColumns.forEach((col) => {
            col.style.zIndex = '6'; // Always higher than content area (5)
          });
          
          // If the clicked column wasn't active, make it active
          if (!isActive) {
            column.classList.add('GangMembers__Column--active');
            container.classList.add('GangMembers__Container--has-active');
            
            // Set z-index and opacity for active column immediately
            column.style.zIndex = '10';
            column.style.opacity = '1';
            
            // Update content area with the active column's content image (desktop or mobile)
            if (contentArea) {
              let contentImageUrl = '';
              if (isMobileNow) {
                // Use mobile image, fallback to desktop if mobile not available
                contentImageUrl = column.getAttribute('data-content-image-mobile');
                if (!contentImageUrl || contentImageUrl === '') {
                  contentImageUrl = column.getAttribute('data-content-image-desktop');
                }
              } else {
                // Use desktop image
                contentImageUrl = column.getAttribute('data-content-image-desktop');
              }
              
              if (contentImageUrl && contentImageUrl !== '') {
                // Show loading indicator
                contentArea.innerHTML = '<div class="GangMembers__Loader"></div>';
                contentArea.style.opacity = '1';
                contentArea.style.visibility = 'visible';
                contentArea.style.zIndex = '5';
                
                // Preload and then show image
                const img = new Image();
                img.onload = function() {
                  contentArea.innerHTML = '<img src="' + contentImageUrl + '" alt="Content" />';
                  // Fade in effect
                  const imgElement = contentArea.querySelector('img');
                  if (imgElement) {
                    imgElement.style.opacity = '0';
                    imgElement.style.transition = 'opacity 0.3s ease';
                    requestAnimationFrame(function() {
                      imgElement.style.opacity = '1';
                    });
                  }
                };
                img.onerror = function() {
                  contentArea.innerHTML = '';
                };
                img.src = contentImageUrl;
              } else {
                // Clear if no content image
                contentArea.innerHTML = '';
              }
              // Ensure content area is visible with full opacity
              contentArea.style.opacity = '1';
              contentArea.style.visibility = 'visible';
              contentArea.style.zIndex = '5';
            }
            
            // Remove any existing spacer
            const existingSpacer = container.querySelector('.GangMembers__Spacer');
            if (existingSpacer) {
              existingSpacer.remove();
            }
            
            // Get current index from fresh columns array
            const currentIndex = currentColumns.indexOf(column);
            
            // Add spacer to maintain space for active column (only if not first column)
            if (currentIndex > 0) {
              const spacer = document.createElement('div');
              spacer.className = 'GangMembers__Spacer';
              if (isMobileNow) {
                // Mobile: spacer maintains vertical space
                spacer.style.flex = '0 0 20%';
                spacer.style.width = '100%';
                spacer.style.height = '20%';
              } else {
                // Desktop: spacer maintains horizontal space
                spacer.style.flex = '0 0 20%';
                spacer.style.width = '20%';
                spacer.style.height = '100%';
              }
              container.insertBefore(spacer, column);
            }
            
            // Apply transforms based on column position
            currentColumns.forEach((col, colIndex) => {
              // Ensure all columns have full opacity
              col.style.opacity = '1';
              
              if (isMobileNow) {
                // MOBILE: Vertical layout - columns move up/down
                if (colIndex < currentIndex) {
                  // Columns above active column: push off screen to the top
                  const topPosition = (colIndex * 20) + '%';
                  col.style.top = topPosition;
                  // Move up by (colIndex + 1) * 20% of container = (colIndex + 1) * 100% of column height
                  const translateAmount = ((colIndex + 1) * 100) + '%';
                  col.style.transform = 'translateY(-' + translateAmount + ')';
                  col.style.zIndex = '6';
                  col.dataset.columnState = 'top-off';
                } else if (colIndex > currentIndex) {
                  // Columns below active column: push off screen to the bottom
                  const topPosition = (colIndex * 20) + '%';
                  col.style.top = topPosition;
                  // Remaining space from column top edge to bottom edge = 100% - (colIndex * 20%)
                  // Convert to translateY units: (100 - colIndex * 20) * 5 = (500 - colIndex * 100)%
                  const remainingSpacePercent = 100 - (colIndex * 20);
                  const translateAmount = (remainingSpacePercent * 5) + '%';
                  col.style.transform = 'translateY(' + translateAmount + ')';
                  col.style.zIndex = '6';
                  col.dataset.columnState = 'bottom-off';
                } else {
                  // Active column: move to top (position 0%)
                  if (currentIndex === 0) {
                    col.style.transform = 'translateY(0)';
                    col.style.top = '';
                  } else {
                    // Set position absolute first
                    const naturalTop = (currentIndex * 20) + '%';
                    col.style.top = naturalTop;
                    // Force reflow to ensure top is applied
                    col.offsetHeight;
                    // Now animate translateY to move it to 0%
                    col.style.transform = 'translateY(-' + (currentIndex * 100) + '%)';
                  }
                  col.style.bottom = '';
                  col.dataset.columnState = 'active';
                }
              } else {
                // DESKTOP: Horizontal layout - columns move left/right (original logic)
                if (colIndex < currentIndex) {
                  // Columns to the left of active column: push off screen to the left
                  const leftPosition = (colIndex * 20) + '%';
                  col.style.left = leftPosition;
                  // Move left by (colIndex + 1) * 20% of container = (colIndex + 1) * 100% of column width
                  const translateAmount = ((colIndex + 1) * 100) + '%';
                  col.style.transform = 'translateX(-' + translateAmount + ')';
                  col.style.zIndex = '6'; // Always higher than content area (5)
                  col.dataset.columnState = 'left-off';
                } else if (colIndex > currentIndex) {
                  // Columns to the right of active column: push off screen to the right
                  const leftPosition = (colIndex * 20) + '%';
                  col.style.left = leftPosition;
                  // Remaining space from column left edge to right edge = 100% - (colIndex * 20%)
                  // Convert to translateX units: (100 - colIndex * 20) * 5 = (500 - colIndex * 100)%
                  const remainingSpacePercent = 100 - (colIndex * 20);
                  const translateAmount = (remainingSpacePercent * 5) + '%';
                  col.style.transform = 'translateX(' + translateAmount + ')';
                  col.style.zIndex = '6'; // Always higher than content area (5)
                  col.dataset.columnState = 'right-off';
                } else {
                  // Active column: move to left (position 0%)
                  // For column 1 (index 0), it stays at 0%, no transform needed
                  // For columns 2-5, they need to move left from their natural position to 0%
                  if (currentIndex === 0) {
                    col.style.transform = 'translateX(0)';
                    col.style.left = '';
                  } else {
                    // Set position absolute first
                    const naturalLeft = (currentIndex * 20) + '%';
                    col.style.left = naturalLeft;
                    // Force reflow to ensure left is applied
                    col.offsetHeight;
                    // Now animate translateX to move it to 0%
                    // translateX(-100%) moves it left by 20% of container (1 column width)
                    // translateX(-200%) moves it left by 40% of container (2 column widths)
                    // translateX(-300%) moves it left by 60% of container (3 column widths)
                    // translateX(-400%) moves it left by 80% of container (4 column widths)
                    col.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
                  }
                  col.style.right = '';
                  col.dataset.columnState = 'active';
                }
              }
            });
          }
        });
      });
    });
  }

  // Initialize content area for active column on page load
  function initializeContentArea() {
    const containers = document.querySelectorAll('.GangMembers__Container');
    const mobile = isMobile();
    
    containers.forEach(container => {
      const activeColumn = container.querySelector('.GangMembers__Column--active');
      const contentArea = container.querySelector('.GangMembers__ContentArea');
      
      if (activeColumn && contentArea) {
        let contentImageUrl = '';
        if (mobile) {
          // Use mobile image, fallback to desktop if mobile not available
          contentImageUrl = activeColumn.getAttribute('data-content-image-mobile');
          if (!contentImageUrl || contentImageUrl === '') {
            contentImageUrl = activeColumn.getAttribute('data-content-image-desktop');
          }
        } else {
          // Use desktop image
          contentImageUrl = activeColumn.getAttribute('data-content-image-desktop');
        }
        
        if (contentImageUrl && contentImageUrl !== '') {
          // Show loading indicator initially
          contentArea.innerHTML = '<div class="GangMembers__Loader"></div>';
          contentArea.style.opacity = '1';
          contentArea.style.visibility = 'visible';
          contentArea.style.zIndex = '5';
          
          // Preload and show image
          const img = new Image();
          img.onload = function() {
            contentArea.innerHTML = '<img src="' + contentImageUrl + '" alt="Content" />';
            const imgElement = contentArea.querySelector('img');
            if (imgElement) {
              imgElement.style.opacity = '0';
              imgElement.style.transition = 'opacity 0.3s ease';
              requestAnimationFrame(function() {
                imgElement.style.opacity = '1';
              });
            }
          };
          img.onerror = function() {
            contentArea.innerHTML = '';
          };
          img.src = contentImageUrl;
        }
      }
    });
  }

  // Initialize on DOM ready
  function initializeOnReady() {
    // Reset all columns to initial state
    const containers = document.querySelectorAll('.GangMembers__Container');
    containers.forEach(container => {
      const columns = Array.from(container.querySelectorAll('.GangMembers__Column'));
      columns.forEach((col, colIndex) => {
        // Reset all transforms and positions (both horizontal and vertical)
        col.style.transform = '';
        col.style.left = '';
        col.style.right = '';
        col.style.top = '';
        col.style.bottom = '';
        col.dataset.columnState = 'normal';
        // Only first column should be active
        if (colIndex === 0) {
          col.classList.add('GangMembers__Column--active');
        } else {
          col.classList.remove('GangMembers__Column--active');
        }
      });
      // Remove any spacers
      const existingSpacer = container.querySelector('.GangMembers__Spacer');
      if (existingSpacer) {
        existingSpacer.remove();
      }
      container.classList.remove('GangMembers__Container--has-active');
    });
    
    // Preload all content images in background
    preloadAllContentImages();
    
    // Initialize content area for active column
    initializeContentArea();
    
    // Then initialize the click handlers
    initGangMembers();
  }

  // Initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOnReady);
  } else {
    // Use setTimeout to ensure DOM is fully ready
    setTimeout(initializeOnReady, 0);
  }

  // Re-initialize if new content is loaded (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', initGangMembers);
  }

  // Re-initialize on window resize to handle orientation changes
  let resizeTimeout;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      // Reset all columns and reinitialize
      const containers = document.querySelectorAll('.GangMembers__Container');
      containers.forEach(container => {
        const columns = Array.from(container.querySelectorAll('.GangMembers__Column'));
        const activeColumn = container.querySelector('.GangMembers__Column--active');
        
        columns.forEach((col) => {
          col.removeAttribute('data-listener-attached');
          col.style.transform = '';
          col.style.left = '';
          col.style.right = '';
          col.style.top = '';
          col.style.bottom = '';
          col.dataset.columnState = 'normal';
        });
        // Remove any spacers
        const existingSpacer = container.querySelector('.GangMembers__Spacer');
        if (existingSpacer) {
          existingSpacer.remove();
        }
        container.classList.remove('GangMembers__Container--has-active');
        
        // Re-initialize content area with correct image for new device type
        if (activeColumn) {
          const contentArea = container.querySelector('.GangMembers__ContentArea');
          const mobile = isMobile();
          
          if (contentArea) {
            let contentImageUrl = '';
            if (mobile) {
              contentImageUrl = activeColumn.getAttribute('data-content-image-mobile');
              if (!contentImageUrl || contentImageUrl === '') {
                contentImageUrl = activeColumn.getAttribute('data-content-image-desktop');
              }
            } else {
              contentImageUrl = activeColumn.getAttribute('data-content-image-desktop');
            }
            
            if (contentImageUrl && contentImageUrl !== '') {
              // Show loading indicator
              contentArea.innerHTML = '<div class="GangMembers__Loader"></div>';
              
              // Preload and show image
              const img = new Image();
              img.onload = function() {
                contentArea.innerHTML = '<img src="' + contentImageUrl + '" alt="Content" />';
                const imgElement = contentArea.querySelector('img');
                if (imgElement) {
                  imgElement.style.opacity = '0';
                  imgElement.style.transition = 'opacity 0.3s ease';
                  requestAnimationFrame(function() {
                    imgElement.style.opacity = '1';
                  });
                }
              };
              img.onerror = function() {
                contentArea.innerHTML = '';
              };
              img.src = contentImageUrl;
            }
          }
        }
        
        // Re-preload images for new device type
        preloadAllContentImages();
      });
      // Reinitialize with new layout
      initializeOnReady();
    }, 250);
  });
})();

